<template>
    <div class="home">
        <div class="project-list">
            <el-card style="width: 100%">
                <template #header>
                    <div class="card-header">
                        <span>厕所容易找</span>
                    </div>
                </template>
                <div>
                    <el-row :gutter="20">
                        <el-col :span="6"><div class="grid-content ep-bg-purple" />
                            <div class="data-number">
                                <span>总用户数</span>
                                <h3>{{toiletData.total}}</h3>
                            </div>
                        </el-col>
                        <el-col :span="6"><div class="grid-content ep-bg-purple" />
                            <div class="data-number" style="border-left: 1px solid #e7e7eb">
                                <span>今日注册</span>
                                <h3>{{toiletData.todayRes}}</h3>
                            </div></el-col>
                        <el-col :span="6"><div class="grid-content ep-bg-purple" />
                            <div class="data-number" style="border-left: 1px solid #e7e7eb">
                                <span>昨日注册</span>
                                <h3>{{toiletData.yesTodayRes}}</h3>
                            </div>
                        </el-col>
                        <el-col :span="6"><div class="grid-content ep-bg-purple" />
                            <div class="data-number" style="border-left: 1px solid #e7e7eb">
                                <span>七日内注册</span>
                                <h3>{{toiletData.sevenRes}}</h3>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
        </div>
        <div class="project-list">
            <el-card style="width: 100%">
                <template #header>
                    <div class="card-header">
                        <span>星星水印</span>
                    </div>
                </template>
                <div>
                    <el-row :gutter="20">
                        <el-col :span="6"><div class="grid-content ep-bg-purple" />
                            <div class="data-number">
                                <span>总用户数</span>
                                <h3>{{waterPrintData.total}}</h3>
                            </div>
                        </el-col>
                        <el-col :span="6"><div class="grid-content ep-bg-purple" />
                            <div class="data-number" style="border-left: 1px solid #e7e7eb">
                                <span>今日注册</span>
                                <h3>{{waterPrintData.todayRes}}</h3>
                            </div></el-col>
                        <el-col :span="6"><div class="grid-content ep-bg-purple" />
                            <div class="data-number" style="border-left: 1px solid #e7e7eb">
                                <span>昨日注册</span>
                                <h3>{{waterPrintData.yesTodayRes}}</h3>
                            </div>
                        </el-col>
                        <el-col :span="6"><div class="grid-content ep-bg-purple" />
                            <div class="data-number" style="border-left: 1px solid #e7e7eb">
                                <span>七日内注册</span>
                                <h3>{{waterPrintData.sevenRes}}</h3>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
        </div>
        <el-card style="width: 100%">
            <template #header>
                <div class="card-header">
                    <span>报表</span>
                </div>
            </template>
            <div class="dataCount">
                <div>
                    <div id="main1" style="width:100%;height: 300px"></div>
                </div>
                <div>
                    <div id="main2" style="width:100%;height: 300px"></div>
                </div>
            </div>
        </el-card>

    </div>
</template>

<script setup>
    import { defineComponent, onMounted, reactive,ref, nextTick, unref} from 'vue';
    import { ElMessage,ElMessageBox  } from 'element-plus/lib/components';
    import {getDayCount,getMonthCount,getLineCountThirty} from '@/api/index'
    import * as echarts from 'echarts';
    function handle_getDayCount(source){
        getDayCount({source:source}).then(data => {
           if(data.code==200){
               if(source==1){
                   toiletData.total = data.data.total
                   toiletData.todayRes = data.data.todayRes
                   toiletData.yesTodayRes = data.data.yesTodayRes
                   toiletData.sevenRes = data.data.sevenRes
               }else if(source==2){
                   waterPrintData.total = data.data.total
                   waterPrintData.todayRes = data.data.todayRes
                   waterPrintData.yesTodayRes = data.data.yesTodayRes
                   waterPrintData.sevenRes = data.data.sevenRes
               }

           }
        })
    }
    function handle_getMonthCount(){
        getMonthCount().then(data=>{
            console.log(data)
            if(data.code==200){
                if(data.data.length>0){
                    let obj = {
                        month:[],
                        data1:[],
                        data2:[]
                    }
                    for(let i=0;i<data.data.length;i++){
                        if(data.data[i].source==1){
                            obj.month.push(data.data[i].date)
                            obj.data1.push(data.data[i].count)
                        }
                        if(data.data[i].source==2){
                            obj.data2.push(data.data[i].count)
                        }
                    }
                    getCountStatisticsSeven(obj)
                }
            }
        })
    }
    //厕所容易找
    let toiletData = reactive({
        total:0,
        todayRes:0,
        yesTodayRes:0,
        sevenRes:0
    })
    //厕所容易找
    let waterPrintData = reactive({
        total:0,
        todayRes:0,
        yesTodayRes:0,
        sevenRes:0
    })
    function getCountStatisticsSeven(obj){
        // 基于准备好的dom，初始化echarts实例
        console.log(obj,7788)
        var myChart = echarts.init(document.getElementById('main1'));
        // 绘制图表
        myChart.setOption({
            title: {
                text: '7日注册',
                left:"center",
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: ['厕所容易找', '星星水印',],
                bottom:0
            },
            xAxis: {
                data: obj.month
            },
            yAxis: {},
            series: [
                {
                    name: '厕所容易找',
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    data: obj.data1
                },
                {
                    name: '星星水印',
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    data: obj.data2
                }
            ]
        });
    }
    function handle_getLineCountThirty(){
        getLineCountThirty().then(data=>{
            if(data.code==200){
                if(data.data.length>0){
                    let obj = {
                        month:[],
                        data1:[],
                        data2:[]
                    }
                    for(let i=0;i<data.data.length;i++){
                        if(data.data[i].source==1){
                            obj.month.push(data.data[i].date)
                            obj.data1.push(data.data[i].count)
                        }
                        if(data.data[i].source==2){
                            obj.data2.push(data.data[i].count)
                        }else{
                            obj.data2 = []
                        }
                    }
                    console.log(obj,"obj")
                    getCountStatisticsThirty(obj)
                }
            }
        })
    }
    function getCountStatisticsThirty(obj){
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('main2'));
        // 绘制图表
        myChart.setOption({
            title: {
                text: '30日注册',
                left:"center",

            },
            legend: {
                data: ['厕所容易找', '星星水印',],
                bottom:0
            },
            tooltip: {
                trigger: 'axis'
            },
            xAxis: {
                data: obj.month
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    name: '厕所容易找',
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    data: obj.data1
                },
                {
                    name: '星星水印',
                    type: 'line',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    data: obj.data2
                }
            ]
        });
    }
    onMounted(() => {
        // getCountStatisticsSeven()
        // getCountStatisticsThirty()
        handle_getLineCountThirty()
        // handle_getMonthCount()
        handle_getMonthCount()
        handle_getDayCount(1)
        handle_getDayCount(2)
    })
</script>
<style lang="scss" scoped>
    .home{
        width: 98.6%;
        margin: 0 auto;
        .project-list{
            margin-bottom: 10px;
            .data-number{
                text-align: center;
                span{
                    color: #9a9a9a;
                }
                h3{
                    color: #353535;
                    font-size: 16px;
                    margin-top: 10px;
                }
            }
        }
    }
    .card-header{
        span{
            display: block;
            border-left: 4px solid #54AEFF;
            padding-left: 10px;
        }
    }
    .dataCount{

        overflow: hidden;
        display: flex;
        justify-content: space-between;
        >div{
            background: #fff;
            width: 49.6%;
            padding-top: 15px;
        }
    }
    #main{

    }
</style>
